module.exports = __webpack_public_path__ + "static/galapagosLogo-5ae70f19b5b6d5059da76c0fb8b361f6.svg";